import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const usePromotionStore = defineStore("promotion", {
  state: () => {
    return {
      promotions: [],
      scope: "all",
      page: 1,
      pageCount: 0,
      perPage: 30,
      queryString: "",
      currentObj: {},
    };
  },
});

export const storePromotion = usePromotionStore(pinia);
